"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndividualTrialState = void 0;
const zod_1 = require("zod");
exports.IndividualTrialState = zod_1.z.enum([
    "active", // trial has more than two days remaining until expiry
    "expiring", // trial has two or fewer days remaining until expiry
    "expired", // trial has expired, and is no longer active (NOTE: may have been canceled before expiry date)
    "none", // trial has never been on a trial
]);
//# sourceMappingURL=trial.js.map